import { request } from '@/shared/api/request'

export const exportData = ({ params }) =>
	request({ url: `contract/sl/upload`, method: 'POST', responseType: 'blob', data: params })

export const downloadData = (id) =>
	request({ url: `contract/sl/${id}/pdf`, method: 'GET', responseType: 'blob'})

export const downloadDataEmpl = ({id, params}) =>
	request({ url: `contract/sl/${id}/pdfEmpl`, method: 'GET', responseType: 'blob', params: params})
